module.exports = {
  usual: {
    key: 'usual',
    label: 'Preferred',
  },
  official: {
    key: 'official',
    label: 'Official',
  },
  temp: {
    key: 'temp',
    label: 'Temp',
  },
  nickname: {
    key: 'nickname',
    label: 'Nickname',
  },
  anonymous: {
    key: 'anonymous',
    label: 'Anonymous',
  },
  old: {
    key: 'old',
    label: 'Old',
  },
  maiden: {
    key: 'maiden',
    label: 'Maiden',
  },
};